import { render, staticRenderFns } from "./VLoading.vue?vue&type=template&id=13c5bac8&scoped=true"
import script from "./VLoading.vue?vue&type=script&lang=js"
export * from "./VLoading.vue?vue&type=script&lang=js"
import style0 from "./VLoading.vue?vue&type=style&index=0&id=13c5bac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5bac8",
  null
  
)

export default component.exports